module.exports = __webpack_public_path__ + "img/17.5b87e5ac.jpeg";